import { lazy } from 'react';

const ProductCatalogsList = lazy(() => import('./ProductCatalogsList'));

const ProductCatalogsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'product-catalogs',
      element: <ProductCatalogsList />,
    },
  ],
};

export default ProductCatalogsConfig;
